import {
    Component,
    Input,
    Output,
    EventEmitter,
    ViewChild,
    TemplateRef,
    AfterViewInit
} from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap";
import {
    FormControl
} from "@angular/forms";
import { ToasterService } from "angular2-toaster";
import { CommonService } from "../../services/index";
import * as _ from "lodash";
import { OLD_CLIENT_FOLLOWUP_ID } from "../../shared/config/followup";

@Component({
    selector: "single-client-details",
    templateUrl: "./clientDetails.component.html"
})
export class clientDetailsComponent implements AfterViewInit {
    //public clientStatus: any[] = [];
    @Input() showClientHistory;
    @Input() showDetails;
    @Input() showServiceHistory;
    @Input() showClientlastSales;
    @Input() showClientlastTrail;
    isLoadMask: Promise<any>;
    //loadingIndicator: boolean = true;
    //branchList: BranchList[] = [];

    //common Ngmodel name
    //clientStatus: any[]=[];
    // _params: any[] = [];
    // @Input() set clientStatus(val: any){
    //     this._params = val;
    // }
    clientCtrl: FormControl;
    statusCtrl: FormControl;
    @Output() clientOutLoadEvent = new EventEmitter();
    @Output() followUpClientEvent = new EventEmitter();
    clientdata = [];
    isLoading: boolean = false;
    itemList: any[] = [];
    imagePath = "";
    page_from = "";
    //ser_id = '';
    // @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    // @ViewChild('filterPanel') filterPanel;
    salesDet = [];
    lastSalBillDet = [];
    loadingIndicator: boolean = true;
    columns = [];
    serviceColumns = [];
    trailColumns = [];
    serviceHistoryList = [];
    followUpHistoryList = [];
    trailMachineDetails = [];
    ServiceColumnHistoryList = [];
    servicedata = [];
    servicecnt: any;
    servicePage = {
        limit: 10,
        count: 0,
        offset: 0,
        orderBy: "date",
        orderDir: "desc"
    };
    scrollTimeoutSerGrid: any;
    suppressPagingSerGrid: boolean = false;
    historyPage = {
        limit: 100,
        count: 0,
        offset: 0,
        orderBy: "date",
        orderDir: "desc"
    };
    scrollTimeoutHisGrid: any;
    suppressPagingHisGrid: boolean = false;
    trialPage = {
        limit: 10,
        count: 0,
        offset: 0,
        orderBy: "date",
        orderDir: "desc"
    };
    scrollTimeoutTrialGrid: any;
    suppressPagingTrialGrid: boolean = false;
    ezCrmDetail: any = null;
    ezCrmDetailLoading: boolean = false;
    ezCrmModalRef: BsModalRef;
    objectKeys = Object.keys;

    @ViewChild('ezIconTemplate') ezIconTemplate: TemplateRef<any>;
    @ViewChild('ezCrmDetailModal') ezCrmDetailModal: TemplateRef<any>;
    constructor(
        public toasterService: ToasterService,
        private commonService: CommonService,
        private modalService: BsModalService
    ) { }

    ngOnInit(): void {
        //this.loadSingleClientDetails();
        this.columns = [
            {
                name: "Date",
                prop: "act_date",
                width: 100,
                minWidth: 100,
                maxWidth: 100,
                toggle: true
            },
            /*{
                name: "Followed Date",
                prop: "fol_date",
                width: 100,
                minWidth: 100,
                maxWidth: 100,
                toggle: true
            },*/
            {
                name: "Description",
                prop: "description",
                sortable: false,
                width: 300,
                minWidth: 300,
                maxWidth: 300
            },
            {
                name: "Status",
                prop: "status_name",
                sortable: false,
                cellClass: "cell-left",
                width: 120,
                minWidth: 120,
                maxWidth: 120
            }
        ];

        this.serviceColumns = [
            {
                name: "Model",
                prop: "model_name",
                width: 200,
                minWidth: 200,
                maxWidth: 200,
                toggle: true
            },
            {
                name: "Serial No", prop: "serial_no", width: 140,
                minWidth: 140, maxWidth: 140
            },
            {
                name: "Brand", prop: "brand_name", width: 120,
                minWidth: 120, maxWidth: 120
            },
            {
                name: "Brand Model", prop: "brand_model_name", width: 140,
                minWidth: 140, maxWidth: 140
            },
            {
                name: "Family", prop: "family_name", width: 100,
                minWidth: 100, maxWidth: 100
            },
            {
                name: "Series", prop: "series_name", width: 100,
                minWidth: 100, maxWidth: 100
            },
            {
                name: "Performance", prop: "performance_name", width: 130,
                minWidth: 130, maxWidth: 130
            },
            {
                name: "Power", prop: "power_name", width: 100,
                minWidth: 100, maxWidth: 100
            },
            {
                name: "Battery", prop: "battery_name", width: 100,
                minWidth: 100, maxWidth: 100
            },
            {
                name: "Color", prop: "color_name", width: 120,
                minWidth: 120, maxWidth: 120
            },
            {
                name: "Quantity", prop: "qty", width: 100,
                minWidth: 100, maxWidth: 100
            }
        ];

        this.trailColumns = [
            {
                name: "Model Name",
                prop: "model_name",
                width: 200,
                minWidth: 200,
                maxWidth: 200,
                toggle: true
            },
            {
                name: "Brand Name",
                prop: "brand_name",
                width: 200,
                minWidth: 200,
                maxWidth: 200
            },
            {
                name: "MRP", prop: "mrp", width: 100,
                minWidth: 100, maxWidth: 100
            },
            {
                name: "Machine Type",
                prop: "machine_type",
                width: 200,
                minWidth: 200,
                maxWidth: 200
            }
        ];
    }
    //SERVICE GRID
    pageCallbackServiceGrid(pageInfo: {
        count?: number;
        pageSize?: number;
        limit?: number;
        offset?: number;
    }) {
        this.servicePage.offset = pageInfo.offset;
        //this.getClientHistory();
    }
    onScrollServiceGrid() {
        this.suppressPagingSerGrid = true;
        if (this.scrollTimeoutSerGrid) {
            //celarTimeout(this.scrollTimeoutSerGrid);
        }
        this.scrollTimeoutSerGrid = setTimeout(() => {
            this.suppressPagingSerGrid = false;
        }, 100);
    }
    //FOLLOW-UP HISTORY GRID
    pageCallbackHistoryGrid(pageInfo: {
        count?: number;
        pageSize?: number;
        limit?: number;
        offset?: number;
    }) {
        this.historyPage.offset = pageInfo.offset;
        //this.getClientHistory();
    }
    onScrollHistoryGrid() {
        this.suppressPagingHisGrid = true;
        if (this.scrollTimeoutHisGrid) {
            //celarTimeout(this.scrollTimeoutHisGrid);
        }
        this.scrollTimeoutHisGrid = setTimeout(() => {
            this.suppressPagingHisGrid = false;
        }, 100);
    }
    //SERVICE GRID
    pageCallbackTrialGrid(pageInfo: {
        count?: number;
        pageSize?: number;
        limit?: number;
        offset?: number;
    }) {
        this.trialPage.offset = pageInfo.offset;
        //this.getClientHistory();
    }
    onScrollTrialGrid() {
        this.suppressPagingTrialGrid = true;
        if (this.scrollTimeoutTrialGrid) {
            //celarTimeout(this.scrollTimeoutTrialGrid);
        }
        this.scrollTimeoutTrialGrid = setTimeout(() => {
            this.suppressPagingTrialGrid = false;
        }, 100);
    }

    getClientHistory(clientID): void {
        if (!this.suppressPagingHisGrid) {
            let that = this,
                params = {
                    start: `${this.historyPage.offset}`,
                    limit: `${this.historyPage.limit}`,
                    orderColumn: `${this.historyPage.orderBy}`,
                    orderDir: `${this.historyPage.orderDir}`,
                    from_page: "followUp",
                    client_id: clientID
                };
            this.loadingIndicator = true;
            this.isLoadMask = this.commonService
                .getClientHistory(params)
                .then(function (res: any) {
                    that.loadingIndicator = false;
                    that.historyPage.count = res.totCnt;
                    if (res && res.data && res.data.length > 0) {
                        res.data[0].description += " " + res.data[0].next_followp_date;
                    }
                    that.followUpHistoryList = res.data;
                    that.servicedata = res.service_history;
                    that.servicecnt = res.servicecnt;
                    that.ServiceColumnHistoryList = res.service_headers;
                    that.clientdata['walkindate'] = res.walkindate;
                });
        }
    }

    getClientMobileNo(clientID): void {
        if (!this.suppressPagingHisGrid) {
            let that = this,
                params = {
                    client_id: clientID
                };
            this.loadingIndicator = true;
            this.isLoadMask = this.commonService
                .getClientMobileNo(params)
                .then(function (res: any) {
                    that.clientdata['mobile'] = res.data.mobile;
                });
        }
    }

    loadClient(clientRec) {
        let clientID = clientRec;
        if (typeof clientRec == "object") {
            clientID = clientRec["client_id"];
            this.clientdata = clientRec;
            if (!_.isEmpty(clientRec["client_photo"])) {
                this.imagePath = "assets/client/" + clientRec["client_photo"];
            } else {
                this.imagePath = "assets/client/empty.png";
            }
            if (this.showClientHistory != "false") {
                this.getClientMobileNo(clientRec["client_id"]);
                this.getClientHistory(clientRec["client_id"]);
            }
            if (clientRec["followUpTeam"] == "Sold" ||
                clientRec["followUpTeam"] == "AfterSales" ||
                clientRec["followUpTeam"] == "HV" ||
                clientRec["followUpTeam"] == "SOA") {
                this["followUpTeam"] = clientRec["followUpTeam"];
                this.getSalesDetails(clientID);
                this.showClientlastSales = "true";
            }
            if (clientRec["followUpTeam"] == "Unsold" ||
                clientRec["followUpTeam"] == "Promo Unsold") {
                this["followUpTeam"] = clientRec["followUpTeam"];
                this.getTrailDetails(clientID);
                this.showClientlastTrail = "true";
            }
        } else if (
            typeof clientRec == "string" ||
            typeof clientRec == "number"
        ) {
            this.loadSingleClientDetails(clientRec, "", "");
        }
        // if(this.followUpTeam == 'Sales'){
        //     this.getSalesDetails(clientID);
        // }
    }
    loadSingleClientDetails(clientID, page_from, ser_id) {
        let that = this,
            data = {
                client_id: clientID
            };
        this.commonService
            .getSingleClientDetails(data)
            .then(function (res: any) {
                that.clientdata = res.data[0];
                //that.imagePath = 'assets/client/' + res.data[0]['client_photo'];
                if (!_.isEmpty(res.data[0]["client_photo"])) {
                    that.imagePath =
                        "assets/client/" + res.data[0]["client_photo"];
                } else {
                    that.imagePath = "assets/client/empty.png";
                }
                if (that.showClientHistory != "false") {
                    that.getClientHistory(clientID);
                }
                if (that.showServiceHistory == "true") {
                    that.getServiceModel(ser_id);
                }
                //that.clientCtrl.setValue(that.clientdata['ref_id']);
            });
    }
    getServiceModel(serID): void {
        if (!this.suppressPagingSerGrid) {
            let that = this,
                params = {
                    start: `${this.servicePage.offset}`,
                    limit: `${this.servicePage.limit}`,
                    orderColumn: `${this.servicePage.orderBy}`,
                    orderDir: `${this.servicePage.orderDir}`,
                    ser_id: serID
                };
            this.isLoadMask = this.commonService
                .getServiceModel(params)
                .then(function (res: any) {
                    that.loadingIndicator = false;
                    that.servicePage.count = res.totCnt;
                    that.serviceHistoryList = res.data;
                });
        }
    }
    getSalesDetails(clientID): void {
        let that = this,
            params = {
                followUpTeam: this["followUpTeam"],
                client_id: clientID
            };
        this.isLoadMask = this.commonService
            .getSalesDetails(params)
            .then(function (res: any) {
                if (res.success) {
                    that.salesDet = res.data;
                    that.lastSalBillDet = res.modelDet;
                    if (that['followUpTeam'] == 'Sold' || that['followUpTeam'] == 'HV' || that['followUpTeam'] == 'SOA') {
                        that.followUpClientEvent.emit({
                            'fromCall': 'billTab',
                            'next_oneyear_fol_disp_date': res.data.next_oneyear_fol_disp_date,
                            'next_twoyear_fol_disp_date': res.data.next_twoyear_fol_disp_date,
                            'next_onemonth_fol_disp_date' : res.data.next_onemonth_fol_disp_date,
                            'next_sixmonth_fol_disp_date' : res.data.next_sixmonth_fol_disp_date,
                            'next_oneandhalf_year_fol_disp_date': res.data.next_oneandhalf_year_fol_disp_date,
                            'next_twoandhalf_year_fol_disp_date' : res.data.next_twoandhalf_year_fol_disp_date,
                            'warranty' : res.data.warranty,
                            'fol_col_status': res.data.fol_col_status  
                        });
                    }
                }
            });
    } 

    getTrailDetails(clientID): void {
        if (!this.suppressPagingTrialGrid) {
            let that = this,
                params = {
                    followUpTeam: this["followUpTeam"],
                    client_id: clientID
                };
            this.loadingIndicator = true;
            this.isLoadMask = this.commonService
                .getTrailDetails(params)
                .then(function (res: any) {
                    that.loadingIndicator = false;
                    that.trialPage.count = res.totCnt;
                    that.trailMachineDetails = res.data;
                });
        }
    }

    viewEzCrmDetail(row: any) {
        this.ezCrmDetail = null;
        this.ezCrmDetailLoading = true;
        this.ezCrmModalRef = this.modalService.show(this.ezCrmDetailModal, { class: 'modal-lg' });
        this.commonService.getEzCrmCallLogDetail(row.ez_id).then((res: any) => {
            this.ezCrmDetailLoading = false;
            this.ezCrmDetail = res && res.status === 'success' ? res : null;
        }).catch(() => {
            this.ezCrmDetailLoading = false;
        });
    }

    closeEzDetail() {
        if (this.ezCrmModalRef) {
            this.ezCrmModalRef.hide();
        }
    }

    ngAfterViewInit() {
        this.columns = [
            {
                name: "Date",
                prop: "act_date",
                width: 100,
                minWidth: 100,
                maxWidth: 100,
                toggle: true
            },
            {
                name: "Description",
                prop: "description",
                sortable: false,
                width: 300,
                minWidth: 300,
                maxWidth: 300
            },
            {
                name: "Status",
                prop: "status_name",
                sortable: false,
                cellClass: "cell-left",
                width: 120,
                minWidth: 120,
                maxWidth: 120
            },
            {
                name: "View",
                prop: "ez_id",
                sortable: false,
                cellTemplate: this.ezIconTemplate,
                width: 150,
                minWidth: 150,
                maxWidth: 150
            }
        ];
    }

    getRowClass(row) {
        if (row.fol_id == OLD_CLIENT_FOLLOWUP_ID) {
            return {
                'important-follow-up': true
            };
        }
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/common/clientDetails.component.ts